// @flow
import React from 'react'

const BenefitIcons = () => (
  <div className="row">
    <div className="col-sm-4 col-xs-12">
      <img
        alt="time"
        src="/static/images/time.png"
        style={{
          height: '175px',
          display: 'block',
          margin: '0 auto 1rem auto'
        }}
      />
      <div>
        <strong>Benefit from time savings.</strong>
      </div>
      <p>
        Do all your homework from the convenience of your computer, tablet or
        phone. Search any home, schedule tours and even initiate offers right
        from this website.
      </p>
    </div>
    <div className="col-sm-4 col-xs-12">
      <img
        alt="information"
        src="/static/images/information.png"
        style={{
          height: '175px',
          display: 'block',
          margin: '0 auto 1rem auto'
        }}
      />
      <div>
        <strong>Gain a competitive edge.</strong>
      </div>
      <p>
        Find out about new listings before other buyers, stay educated on
        current market values and trends, and use our 10+ years of real estate
        experience to your advantage.
      </p>
    </div>
    <div className="col-sm-4 col-xs-12">
      <img
        alt="savings"
        src="/static/images/savings.png"
        style={{
          height: '175px',
          display: 'block',
          margin: '0 auto 1rem auto'
        }}
      />
      <div>
        <strong>Save your piggy bank.</strong>
      </div>
      <p>
        Not only will you save on your investment from our expert guidance on
        negotiations, but you pay absolutely NOTHING when working with us.
        Better yet, we actually pay you!
      </p>
    </div>
  </div>
)

export default BenefitIcons



// WEBPACK FOOTER //
// ./src/components/BenefitIcons/index.js